import { isEmpty } from 'lodash'

import { TAppTypesDisplaySubsitutes } from 'types/apps'
import { TPermission } from 'types/permissions'

type TValue = {
  name: TAppTypesDisplaySubsitutes
  option: string
  isActiveCheckAccordion: boolean
}

export const setEditRoleValues = (
  value: TValue,
  permissions: TPermission[],
  deletedPermissions: TPermission[],
  setFieldValue: (field: string, value: TPermission[], shouldValidate?: boolean) => void
) => {
  // transform returned value from checkAccordion to have structure like api structure
  const transformedReturnedPermission = {
    subject: value.name as string,
    action: value.option as string,
    userRoleId: '',
    uuid: '',
  }

  // list selected permissions names
  const selectedPersmissionNames = permissions.map(({ subject }) => subject)

  // remove permission which has been already changed
  if (selectedPersmissionNames.includes(transformedReturnedPermission.subject)) {
    // unchecked permissions to remove
    const unSelectedPermissions = permissions.filter(
      ({ subject }) => subject === transformedReturnedPermission.subject
    )

    if (!isEmpty(unSelectedPermissions)) {
      setFieldValue('deletedPermissions', [...deletedPermissions, ...unSelectedPermissions])
    }

    // permissions without old changed permission
    const selectedPermissionWithoutUnSelectedPermission = permissions.filter(
      ({ subject }) => subject !== transformedReturnedPermission.subject
    )

    // if checkbox has been unchecked we have to set permissions array without unchecked permission
    if (value.isActiveCheckAccordion === false) {
      return setFieldValue('permissions', selectedPermissionWithoutUnSelectedPermission)
    }

    // filter old permission
    const oldPermission = permissions.find(
      ({ subject }) => subject === transformedReturnedPermission.subject
    )

    const updatedOldPermission = {
      ...oldPermission,
      action: transformedReturnedPermission.action,
    }

    // new array of permissions including updated permission
    const updatedPermissions = [
      ...selectedPermissionWithoutUnSelectedPermission,
      updatedOldPermission,
    ]

    return setFieldValue('permissions', updatedPermissions as TPermission[])
  } else {
    return setFieldValue('permissions', [...permissions, transformedReturnedPermission])
  }
}
